/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import styled from "styled-components";
import { FormGroup } from "react-bootstrap-3";

const StyledSelect = styled(Select)`
  padding: 0 !important;
  border: none;
`;

function defaultOptionLabelRenderer({ label }) {
  return (
    <div style={{ alignItems: "center", display: "flex" }}>
      <span style={{ fontSize: 14 }}>{label}</span>
    </div>
  );
}

function SearchableSelector({ value, hasErrors, onChange, field, disabled }) {
  const { fieldName, placeholder } = field;
  const optionLabelRenderer = field.optionLabelRenderer || defaultOptionLabelRenderer;
  const selectedValue = field.options.filter(it => it.value === value);
  return (
    <div className={`InputGroup ${field.className}`}>
      <FormGroup>
        <StyledSelect
          {...field}
          formatOptionLabel={optionLabelRenderer}
          isSearchable={true}
          isClearable={true}
          options={field.options}
          onChange={value => onChange({ value: value && value.value, field: fieldName })}
          value={selectedValue}
          placeholder={placeholder}
          isDisabled={disabled}
          className={`form-control ${hasErrors && "parsley-error"}`}
        />
      </FormGroup>
    </div>
  );
}

SearchableSelector.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SearchableSelector;
